import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Transition as _Transition, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "play-page" }
const _hoisted_2 = { class: "play-brand-row" }
const _hoisted_3 = { class: "play-brand-nav" }
const _hoisted_4 = {
  key: 0,
  class: "play-top-links",
  "aria-label": "页面导航"
}
const _hoisted_5 = {
  class: "play-profile-logo",
  "aria-hidden": "true"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "page-shell" }
const _hoisted_8 = { class: "mobile-topbar-title" }
const _hoisted_9 = { class: "play-layout" }
const _hoisted_10 = { class: "play-main-column" }
const _hoisted_11 = ["poster", "muted"]
const _hoisted_12 = ["src", "type"]
const _hoisted_13 = {
  key: 1,
  class: "play-limit-cover"
}
const _hoisted_14 = { class: "play-limit-card" }
const _hoisted_15 = { class: "play-limit-icon" }
const _hoisted_16 = {
  key: 2,
  class: "play-limit-cover vip-limit-cover"
}
const _hoisted_17 = { class: "play-limit-card vip-limit-card" }
const _hoisted_18 = { class: "play-limit-icon vip-limit-icon" }
const _hoisted_19 = {
  key: 3,
  class: "player-message"
}
const _hoisted_20 = { class: "meta-header" }
const _hoisted_21 = { class: "content-section" }
const _hoisted_22 = { class: "content-title-row" }
const _hoisted_23 = { class: "favorite-season-icon" }
const _hoisted_24 = { class: "series-desc" }
const _hoisted_25 = { class: "season-tabs-section" }
const _hoisted_26 = ["data-season-id", "onClick"]
const _hoisted_27 = { class: "episode-panel" }
const _hoisted_28 = { class: "episode-panel-head" }
const _hoisted_29 = { class: "episode-range-section" }
const _hoisted_30 = ["data-range-id", "onClick"]
const _hoisted_31 = ["data-episode-id", "onClick"]
const _hoisted_32 = { class: "episode-cover" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "episode-title" }
const _hoisted_35 = { class: "episode-subtitle" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "sheet-check"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "sheet-check"
}
const _hoisted_40 = { class: "parent-lookup-block" }
const _hoisted_41 = { class: "parent-input-shell" }
const _hoisted_42 = ["type"]
const _hoisted_43 = ["aria-label", "title"]
const _hoisted_44 = {
  key: 0,
  class: "parent-lookup-error",
  role: "alert"
}
const _hoisted_45 = ["disabled"]

import logo2Image from '../assets/logo2.png'
import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getVideoSeasonsList, getVideoEpisodesList, getVideoSeries, type VideoSeries, VideoSeasons, VideoEpisodes } from '@/api/course-video'
import { getFavorites, addFavorites, deleteFavorites } from '@/api/favorites'
import { addHistory } from '@/api/history'
import { getUser, verifyPassword } from '@/api/user'
import { config } from '@/config/axios/config'
import { getAccessToken } from '@/config/axios/auth'
import LoginPromptModal from '@/components/LoginPromptModal.vue'
import VipPromptModal from '@/components/VipPromptModal.vue'

const PARENT_PLAY_LOCK_STORAGE_KEY = 'tree-sprout-player-parent-play-locked'
const VIDEO_PREVIEW_LIMIT_SECONDS = 30

export default /*@__PURE__*/_defineComponent({
  __name: 'player',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const seasons = ref<VideoSeasons[]>([])
const episodes = ref<VideoEpisodes[]>([])
const activeVideoSeries = ref<VideoSeries | null>(null)
const activeSeason = ref<VideoSeasons | null>(null)
const activeEpisode = ref<VideoEpisodes | null>(null)
const activeEpisodeId = ref<number | null>(null)
const activeEpisodeRange = ref('')
const isSeasonSheetOpen = ref(false)
const isEpisodeRangeSheetOpen = ref(false)
const seasonChipsRef = ref(null)
const episodeRangeChipsRef = ref(null)
const episodeGridRef = ref(null)
const videoRef = ref(null)
const isPreviewPlaying = ref(false)
const isMuted = ref(false)
const currentSecond = ref(0)
const videoDuration = ref(0)
const videoError = ref(false)
const playerAspectRatio = ref('16 / 9')
const isTopbarScrolled = ref(false)
const dailyPlayLimitMinutes = ref<number | null>(null)
const watchedTodaySeconds = ref(0)
const isParentUnlocked = ref(false)
const isParentPlayLimitLocked = ref(false)
const isParentUnlockModalOpen = ref(false)
const parentPassword = ref('')
const parentPasswordError = ref('')
const showParentPassword = ref(false)
const parentPasswordInputRef = ref(null)
const isParentPasswordSubmitting = ref(false)
const isFavorites = ref(false)
const isGuestUser = computed(() => getAccessToken() == null)
const isLoginPromptOpen = ref(false)
const isVipPromptOpen = ref(false)
const memberPreviewLimitSeconds = ref<number | null>(null)
const memberPreviewWatchedSeconds = ref(0)
const userVipTag = ref(localStorage.getItem('vipTag') === 'true')
const isNonVipUser = computed(() =>
  !isGuestUser.value && userVipTag.value === false
)
const shouldApplyPreviewLimit = computed(() =>
  (isGuestUser.value || isNonVipUser.value) && memberPreviewLimitSeconds.value != null
)
let isVideoSeeking = false
let lastTrackedVideoSecond = 0
let seekStartVideoSecond = 0

const normalizeMediaUrl = (url?: string) => {
  const rawUrl = url?.trim()
  if (!rawUrl) {
    return ''
  }

  if (rawUrl.startsWith('data:') || rawUrl.startsWith('blob:')) {
    return rawUrl
  }

  try {
    const normalizedUrl = rawUrl.startsWith('//')
      ? new URL(`${window.location.protocol}${rawUrl}`)
      : new URL(rawUrl, config.base_url)

    if (normalizedUrl.protocol === 'http:' && window.location.protocol === 'https:') {
      normalizedUrl.protocol = 'https:'
    }

    return normalizedUrl.href
  } catch {
    return rawUrl
  }
}

const getVideoMimeType = (url: string) => {
  const pathname = url.split('?')[0].split('#')[0].toLowerCase()

  if (pathname.endsWith('.m3u8')) {
    return 'application/vnd.apple.mpegurl'
  }

  if (pathname.endsWith('.mov')) {
    return 'video/quicktime'
  }

  if (pathname.endsWith('.webm')) {
    return 'video/webm'
  }

  return 'video/mp4'
}

const episodeVideoUrl = computed(() => normalizeMediaUrl(activeEpisode.value?.videoUrl))
const episodeVideoType = computed(() => getVideoMimeType(episodeVideoUrl.value))

const filteredEpisodes = computed(() =>
  activeSeason.value
    ? episodes.value.filter((episode) => episode.seasonId === activeSeason.value?.id)
    : []
)

const episodeRanges = computed(() => {
  const groupSize = 15
  const list = filteredEpisodes.value

  return Array.from({ length: Math.ceil(list.length / groupSize) }, (_, index) => {
    const start = index * groupSize
    const items = list.slice(start, start + groupSize)
    const first = start + 1
    const last = start + items.length

    return {
      id: `range-${index + 1}`,
      label: `${first}-${last}`,
      items,
    }
  })
})

const visibleEpisodes = computed(() => {
  const activeRange = episodeRanges.value.find((range) => range.id === activeEpisodeRange.value)
  return activeRange ? activeRange.items : filteredEpisodes.value
})

const getEpisodeNumber = (episode: VideoEpisodes) => {
  const index = filteredEpisodes.value.findIndex((item) => item.id === episode.id)
  return index >= 0 ? index + 1 : ''
}

const filteredEpisodeCountText = computed(() => `共${filteredEpisodes.value.length}集`)

const dailyPlayLimitSeconds = computed(() =>
  dailyPlayLimitMinutes.value == null ? Number.POSITIVE_INFINITY : dailyPlayLimitMinutes.value * 60
)

const hasDailyPlayLimit = computed(() =>
  Number.isFinite(dailyPlayLimitSeconds.value)
)

const canSubmitParentPassword = computed(() =>
  parentPassword.value.trim().length > 0 && !isParentPasswordSubmitting.value
)

const isPlayTimeLimitReached = computed(() =>
  !isGuestUser.value &&
  hasDailyPlayLimit.value &&
  (isParentPlayLimitLocked.value || watchedTodaySeconds.value >= dailyPlayLimitSeconds.value) &&
  !isParentUnlocked.value
)

const isMemberPreviewLimitReached = computed(() =>
  shouldApplyPreviewLimit.value &&
  memberPreviewLimitSeconds.value != null &&
  memberPreviewWatchedSeconds.value >= memberPreviewLimitSeconds.value
)

const shouldShowVipLimitCover = computed(() =>
  isNonVipUser.value && isMemberPreviewLimitReached.value
)

const shouldHideVideoForCover = computed(() =>
  isPlayTimeLimitReached.value || shouldShowVipLimitCover.value
)

const mobileTopbarTitle = computed(() => {
  if (!activeEpisode.value) {
    return ''
  }

  return [activeEpisode.value.name].filter(Boolean).join(' ')
})

const handleLoadedMetadata = () => {
  const video = videoRef.value
  if (!video) {
    return
  }

  videoDuration.value = Number.isFinite(video.duration) ? video.duration : 0
  if (video.videoWidth > 0 && video.videoHeight > 0) {
    playerAspectRatio.value = `${video.videoWidth} / ${video.videoHeight}`
  }

}

const handleVideoLoadStart = () => {
  videoError.value = false

  if (videoRef.value) {
    videoRef.value.muted = false
  }
}

const addWatchedDelta = (watchedDelta, currentVideoSecond) => {
  if (watchedDelta > 0) {
    watchedTodaySeconds.value = Math.min(
      dailyPlayLimitSeconds.value,
      watchedTodaySeconds.value + watchedDelta
    )

    if (shouldApplyPreviewLimit.value) {
      memberPreviewWatchedSeconds.value = Math.min(
        memberPreviewLimitSeconds.value ?? Number.POSITIVE_INFINITY,
        memberPreviewWatchedSeconds.value + watchedDelta
      )
    }
  }

  if (
    !isGuestUser.value &&
    hasDailyPlayLimit.value &&
    watchedTodaySeconds.value >= dailyPlayLimitSeconds.value &&
    !isParentUnlocked.value
  ) {
    isParentPlayLimitLocked.value = true
    window.localStorage.setItem(PARENT_PLAY_LOCK_STORAGE_KEY, '1')
  }

  lastTrackedVideoSecond = currentVideoSecond
  currentSecond.value = currentVideoSecond
}

const trackWatchedVideoTime = (video) => {
  const currentVideoSecond = video.currentTime
  const previousSecond = lastTrackedVideoSecond ?? currentVideoSecond
  const watchedDelta = Math.max(0, currentVideoSecond - previousSecond)

  addWatchedDelta(watchedDelta, currentVideoSecond)
}

const trackSeekedWatchedTime = (video) => {
  const currentVideoSecond = video.currentTime
  const watchedDelta = Math.max(0, currentVideoSecond - seekStartVideoSecond)

  addWatchedDelta(watchedDelta, currentVideoSecond)
}

const enforcePlaybackLimits = () => {
  if (isPlayTimeLimitReached.value) {
    if (!isGuestUser.value && !isParentPlayLimitLocked.value) {
      isParentPlayLimitLocked.value = true
      window.localStorage.setItem(PARENT_PLAY_LOCK_STORAGE_KEY, '1')
    }
    videoRef.value?.pause()
    isPreviewPlaying.value = false
    return true
  }

  return enforcePreviewLimit()
}

const enforcePreviewLimit = () => {
  if (!isMemberPreviewLimitReached.value) {
    return false
  }

  videoRef.value?.pause()
  isPreviewPlaying.value = false

  if (isGuestUser.value) {
    openLoginPrompt()
  } else if (isNonVipUser.value) {
    openVipPrompt()
  }

  return true
}

const handleTimeUpdate = () => {
  const video = videoRef.value
  if (!video) {
    return
  }

  if (isVideoSeeking || video.seeking) {
    currentSecond.value = video.currentTime
    return
  }

  if (enforcePlaybackLimits()) {
    return
  }

  trackWatchedVideoTime(video)

  if (enforcePlaybackLimits()) {
    return
  }

  if (isPlayTimeLimitReached.value) {
    video.pause()
  }
}

const handleVideoPlay = () => {
  if (enforcePlaybackLimits()) {
    return
  }

  lastTrackedVideoSecond = videoRef.value?.currentTime ?? 0
  isPreviewPlaying.value = true
}

const handleVideoPause = () => {
  isPreviewPlaying.value = false
}

const handleVideoSeeking = () => {
  const video = videoRef.value
  if (video) {
    if (!isVideoSeeking) {
      seekStartVideoSecond = lastTrackedVideoSecond ?? video.currentTime
    }

    isVideoSeeking = true
    currentSecond.value = video.currentTime
  }
}

const handleVideoSeeked = () => {
  const video = videoRef.value
  if (video) {
    trackSeekedWatchedTime(video)
    isVideoSeeking = false
    enforcePlaybackLimits()
  }
}

const handleVideoEnded = () => {
  isPreviewPlaying.value = false
}

const handleVideoAbort = () => {
  videoError.value = false
  isPreviewPlaying.value = false
}

const isExpectedMediaAbortError = (reason) => {
  const name = reason?.name || ''
  const code = reason?.code
  const message = [
    reason?.message,
    typeof reason?.toString === 'function' ? reason.toString() : '',
    String(reason || '')
  ].join(' ')

  return (
    name === 'AbortError' ||
    code === 20 ||
    message.includes('fetching process for the media resource was aborted') ||
    message.includes('The play() request was interrupted')
  )
}

const handleVideoError = () => {
  if (videoRef.value?.error?.code === 1) {
    videoError.value = false
    isPreviewPlaying.value = false
    return
  }

  videoError.value = true
  isPreviewPlaying.value = false
}

const handleUnhandledMediaAbortRejection = (event) => {
  if (isExpectedMediaAbortError(event.reason)) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}

const handleGlobalMediaAbortError = (event) => {
  if (isExpectedMediaAbortError(event.error || event.message)) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}

const syncParentPlayLimitLock = () => {
  if (isGuestUser.value || !hasDailyPlayLimit.value) {
    isParentPlayLimitLocked.value = false
    window.localStorage.removeItem(PARENT_PLAY_LOCK_STORAGE_KEY)
    return
  }

  isParentPlayLimitLocked.value =
    window.localStorage.getItem(PARENT_PLAY_LOCK_STORAGE_KEY) === '1'

  if (isParentPlayLimitLocked.value) {
    watchedTodaySeconds.value = dailyPlayLimitSeconds.value
  }
}

const resetPreview = async () => {
  isPreviewPlaying.value = false
  currentSecond.value = 0
  memberPreviewWatchedSeconds.value = 0
  isVideoSeeking = false
  lastTrackedVideoSecond = 0
  seekStartVideoSecond = 0
  videoError.value = false

  await nextTick()

  const video = videoRef.value
  if (video) {
    video.pause()
    try {
      video.currentTime = 0
    } catch {
      // iOS may reject seeking before metadata is available.
    }
  }
}

const openParentUnlockModal = () => {
  parentPassword.value = ''
  parentPasswordError.value = ''
  showParentPassword.value = false
  isParentUnlockModalOpen.value = true

  nextTick(() => {
    parentPasswordInputRef.value?.focus()
  })
}

const closeParentUnlockModal = () => {
  isParentUnlockModalOpen.value = false
  parentPassword.value = ''
  parentPasswordError.value = ''
  showParentPassword.value = false
  isParentPasswordSubmitting.value = false
}

const handleParentUnlock = () => {
  openParentUnlockModal()
}

const submitParentUnlockPassword = async () => {
  if (!parentPassword.value.trim()) {
    parentPasswordError.value = '请输入密码'
    return
  }

  if (isParentPasswordSubmitting.value) {
    return
  }

  isParentPasswordSubmitting.value = true
  parentPasswordError.value = ''

  try {
    const verified = await verifyPassword(parentPassword.value)
    if (!verified) {
      parentPasswordError.value = '密码不正确，请重新输入'
      return
    }

    isParentPlayLimitLocked.value = false
    watchedTodaySeconds.value = 0
    isParentUnlocked.value = false
    window.localStorage.removeItem(PARENT_PLAY_LOCK_STORAGE_KEY)
    closeParentUnlockModal()
    await nextTick()

    const video = videoRef.value
    if (video) {
      lastTrackedVideoSecond = video.currentTime
      try {
        await video.play()
      } catch {
        isPreviewPlaying.value = false
      }
    }
  } catch {
    parentPasswordError.value = '验证失败，请稍后重试'
  } finally {
    isParentPasswordSubmitting.value = false
  }
}

const syncSeasonChipIntoView = () => {
  nextTick(() => {
    const chipsContainer = seasonChipsRef.value
    if (!chipsContainer) {
      return
    }

    const activeChip = chipsContainer.querySelector(
      `button[data-season-id="${activeSeason.value?.id}"]`
    )
    if (!activeChip) {
      return
    }

    activeChip.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })
  })
}

const syncActiveEpisodeRange = () => {
  const ranges = episodeRanges.value
  if (!ranges.length) {
    activeEpisodeRange.value = ''
    return
  }

  const matchedRange = ranges.find((range) =>
    range.items.some((episode) => episode.id === activeEpisodeId.value)
  )

  activeEpisodeRange.value = matchedRange ? matchedRange.id : ranges[0].id
}

const syncEpisodeRangeChipIntoView = () => {
  nextTick(() => {
    const chipsContainer = episodeRangeChipsRef.value
    if (!chipsContainer) {
      return
    }

    const activeChip = chipsContainer.querySelector(
      `button[data-range-id="${activeEpisodeRange.value}"]`
    )
    if (!activeChip) {
      return
    }

    activeChip.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })
  })
}

const syncEpisodeCardIntoView = () => {
  nextTick(() => {
    const grid = episodeGridRef.value
    if (!grid) {
      return
    }

    const activeCard = grid.querySelector(`article[data-episode-id="${activeEpisodeId.value}"]`)
    if (!activeCard) {
      return
    }

    activeCard.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    })
  })
}


const ensureEpisodeInSeason = () => {
  if (!activeSeason.value) {
    return
  }

  const current = episodes.value.find((episode) => episode.id === activeEpisodeId.value)
  if (current && current.seasonId === activeSeason.value.id) {
    return
  }

  const firstEpisode = filteredEpisodes.value[0]
  if (!firstEpisode) {
    return
  }

  activeEpisodeId.value = firstEpisode.id
}

const selectSeason = async (seasonId) => {
  const targetSeason = seasons.value.find((season) => season.id === seasonId)
  if (!targetSeason) {
    return
  }

  activeSeason.value = targetSeason
  const episodesData = await getVideoEpisodesList(route.query.seriesId, targetSeason.id)
  episodes.value = episodesData || []
  const firstEpisode = episodes.value[0] || null
  activeEpisode.value = firstEpisode
  activeEpisodeId.value = firstEpisode?.id || null
  if(!isGuestUser.value) {
    queryFavorite(activeEpisode.value?.id)
    addHistory({contentType: 1, contentId: activeEpisode.value.id})
  }
  syncActiveEpisodeRange()
  resetPreview()
  syncSeasonChipIntoView()
  syncEpisodeRangeChipIntoView()
  syncEpisodeCardIntoView()
}

const selectEpisode = (episodeId) => {
  const target = episodes.value.find((episode) => episode.id === episodeId)
  if (!target) {
    return
  }
  activeEpisodeId.value = target.id
  activeEpisode.value = target
  if(!isGuestUser.value) {
    queryFavorite(activeEpisode.value.id)
    addHistory({contentType: 1, contentId: activeEpisode.value.id})
  }
  syncActiveEpisodeRange()
  resetPreview()
  syncSeasonChipIntoView()
  syncEpisodeRangeChipIntoView()
  syncEpisodeCardIntoView()
}

const selectEpisodeRange = (rangeId) => {
  activeEpisodeRange.value = rangeId
  syncEpisodeRangeChipIntoView()
  syncEpisodeCardIntoView()
}

const toggleSeasonSheet = () => {
  isEpisodeRangeSheetOpen.value = false
  isSeasonSheetOpen.value = !isSeasonSheetOpen.value
}

const closeSeasonSheet = () => {
  isSeasonSheetOpen.value = false
}

const selectSeasonFromSheet = (seasonId) => {
  selectSeason(seasonId)
  closeSeasonSheet()
}

const toggleSeasonFavorite = () => {
  if (!activeEpisode.value) {
    return
  }

  if (isGuestUser.value) {
    openLoginPrompt()
    return
  }

  if (isFavorites.value) {
    deleteFavorites(1, activeEpisode.value.id)
    isFavorites.value = false
  } else {
    addFavorites({contentType: 1, contentId: activeEpisode.value.id})
    isFavorites.value = true
  }
}

const openLoginPrompt = () => {
  isLoginPromptOpen.value = true
}

const openVipPrompt = () => {
  isVipPromptOpen.value = true
}

const goLogin = () => {
  router.push('/login')
}

const goVip = () => {
  isVipPromptOpen.value = false
  router.push('/vip')
}

const toggleEpisodeRangeSheet = () => {
  isSeasonSheetOpen.value = false
  isEpisodeRangeSheetOpen.value = !isEpisodeRangeSheetOpen.value
}

const closeEpisodeRangeSheet = () => {
  isEpisodeRangeSheetOpen.value = false
}

const selectEpisodeFromSheet = (episodeId) => {
  selectEpisode(episodeId)
  closeEpisodeRangeSheet()
}


const scrollPageToTop = () => {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

const handleGoBack = () => {
  if (window.history.length > 1) {
    router.back()
    return
  }

  router.push('/videos')
}

const handlePageScroll = () => {
  isTopbarScrolled.value = window.scrollY > 12
}

const queryFavorite = async(episodeId: number) => {
  try {
    const favorites = await getFavorites(1, episodeId)
    isFavorites.value = favorites != null
  } catch {
    
  }
}

const getQueryNumber = (value) => {
  const rawValue = Array.isArray(value) ? value[0] : value
  const numberValue = Number(rawValue)
  return Number.isFinite(numberValue) ? numberValue : null
}

const normalizeDailyPlayLimitMinutes = (value): number | null => {
  if (value == null || value === '' || value === 'unlimited') {
    return null
  }

  const limitMinutes = Number(value)
  return Number.isFinite(limitMinutes) && limitMinutes > 0 ? limitMinutes : null
}

const loadUserPlaybackLimit = async () => {
  if (isGuestUser.value) {
    dailyPlayLimitMinutes.value = null
    memberPreviewLimitSeconds.value = VIDEO_PREVIEW_LIMIT_SECONDS
    return
  }

  try {
    const user = await getUser()
    userVipTag.value = Boolean(user?.vipTag)
    localStorage.setItem('vipTag', String(userVipTag.value))
    dailyPlayLimitMinutes.value = normalizeDailyPlayLimitMinutes(user?.dailyPlayLimitMinutes)
    memberPreviewLimitSeconds.value = userVipTag.value ? null : VIDEO_PREVIEW_LIMIT_SECONDS
  } catch {
    dailyPlayLimitMinutes.value = normalizeDailyPlayLimitMinutes(
      window.localStorage.getItem('tree-sprout-daily-play-limit')
    )
    memberPreviewLimitSeconds.value = isNonVipUser.value ? VIDEO_PREVIEW_LIMIT_SECONDS : null
  }
}

const getSeasonsList = async () => {
  try {
    const seasonsData = await getVideoSeasonsList(route.query.seriesId)
    seasons.value = seasonsData
    const firstSeason = seasons.value[0]
    if (!firstSeason) {
      episodes.value = []
      activeSeason.value = null
      activeEpisodeId.value = null
      return
    }

    const routeSeasonId = getQueryNumber(route.query.seasonId)
    activeSeason.value = seasons.value.find((season) => season.id === routeSeasonId) || firstSeason

    const episodesData = await getVideoEpisodesList(route.query.seriesId, activeSeason.value.id)
    episodes.value = episodesData || []

    const routeEpisodeId = getQueryNumber(route.query.episodesId)
    activeEpisode.value = episodes.value.find((episode) => episode.id === routeEpisodeId) || episodes.value[0] || null
    activeEpisodeId.value = activeEpisode.value?.id || null

    if (activeEpisode.value && !isGuestUser.value) {
      queryFavorite(activeEpisode.value.id)
      addHistory({contentType: 1, contentId: activeEpisode.value.id})
    }

    getVideoSeriesDetail()
    syncActiveEpisodeRange()
    syncSeasonChipIntoView()
    syncEpisodeRangeChipIntoView()
    syncEpisodeCardIntoView()
  } catch {
    
  }
}

const getVideoSeriesDetail = async() => {
  try {
    activeVideoSeries.value = await getVideoSeries(route.query.seriesId)
  } catch {
    
  }
}

onMounted(async () => {
  window.addEventListener('unhandledrejection', handleUnhandledMediaAbortRejection, true)
  window.addEventListener('error', handleGlobalMediaAbortError, true)
  await loadUserPlaybackLimit()
  syncParentPlayLimitLock()
  await getSeasonsList()
  scrollPageToTop()
  window.addEventListener('scroll', handlePageScroll, { passive: true })
  handlePageScroll()
})

onUnmounted(() => {
  if (videoRef.value) {
    videoRef.value.pause()
  }
  window.removeEventListener('unhandledrejection', handleUnhandledMediaAbortRejection, true)
  window.removeEventListener('error', handleGlobalMediaAbortError, true)
  window.removeEventListener('scroll', handlePageScroll)
})

return (_ctx: any,_cache: any) => {
  const _component_desktop_brand_corner = _resolveComponent("desktop-brand-corner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "bg-gradient" }, null, -1)),
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "orb orb-1" }, null, -1)),
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "orb orb-2" }, null, -1)),
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "orb orb-3" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_desktop_brand_corner, { inline: "" })
      ]),
      (!isGuestUser.value)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "play-nav-link",
              to: "/history"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['far', 'clock'],
                  class: "play-nav-icon"
                }),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "观看记录", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "play-nav-link",
              to: { path: '/history', query: { tab: 'favorites' } }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['far', 'heart'],
                  class: "play-nav-icon"
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "我的收藏", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "play-nav-link",
              to: "/myprofile"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _unref(logo2Image),
                    alt: "",
                    class: "play-profile-logo-img"
                  }, null, 8, _hoisted_6)
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "我的账号", -1))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("main", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["mobile-topbar", { 'is-scrolled': isTopbarScrolled.value }])
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "mobile-back-btn",
          onClick: handleGoBack,
          "aria-label": "返回上一页"
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "chevron-left" })
        ]),
        _createElementVNode("h1", _hoisted_8, _toDisplayString(mobileTopbarTitle.value), 1),
        _cache[11] || (_cache[11] = _createElementVNode("span", {
          class: "mobile-topbar-spacer",
          "aria-hidden": "true"
        }, null, -1))
      ], 2),
      _cache[17] || (_cache[17] = _createElementVNode("div", {
        class: "mobile-topbar-offset",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("section", {
            class: "player-stage",
            style: _normalizeStyle({ aspectRatio: playerAspectRatio.value })
          }, [
            (episodeVideoUrl.value)
              ? (_openBlock(), _createElementBlock("video", {
                  key: episodeVideoUrl.value,
                  ref_key: "videoRef",
                  ref: videoRef,
                  class: _normalizeClass(["player-video", { hidden: shouldHideVideoForCover.value }]),
                  poster: activeEpisode.value?.coverUrl || '',
                  muted: isMuted.value,
                  preload: "auto",
                  controls: "",
                  "x-webkit-airplay": "allow",
                  airplay: "allow",
                  playsinline: "",
                  "webkit-playsinline": "",
                  onLoadstart: handleVideoLoadStart,
                  onPlay: handleVideoPlay,
                  onPause: handleVideoPause,
                  onLoadedmetadata: handleLoadedMetadata,
                  onSeeking: handleVideoSeeking,
                  onSeeked: handleVideoSeeked,
                  onTimeupdate: handleTimeUpdate,
                  onEnded: handleVideoEnded,
                  onAbort: handleVideoAbort,
                  onError: handleVideoError
                }, [
                  _createElementVNode("source", {
                    src: episodeVideoUrl.value,
                    type: episodeVideoType.value
                  }, null, 8, _hoisted_12)
                ], 42, _hoisted_11))
              : _createCommentVNode("", true),
            (isPlayTimeLimitReached.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_font_awesome_icon, { icon: "moon" })
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("p", { class: "play-limit-text" }, "小朋友，休息时间到了！", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "parent-unlock-btn",
                      onClick: handleParentUnlock
                    }, " 家长解锁 ")
                  ])
                ]))
              : (shouldShowVipLimitCover.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_font_awesome_icon, { icon: "crown" })
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("p", { class: "play-limit-text vip-limit-text" }, "成为会员后可观看完整内容", -1))
                    ])
                  ]))
                : (videoError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, "视频加载失败，请稍后重试"))
                  : _createCommentVNode("", true)
          ], 4),
          _createElementVNode("header", _hoisted_20, [
            _createElementVNode("section", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "section-title" }, "简介", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["favorite-season-btn", { active: isFavorites.value }]),
                  onClick: toggleSeasonFavorite
                }, [
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_font_awesome_icon, { icon: "heart" })
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "favorite-season-text" }, "收藏", -1))
                ], 2)
              ]),
              _createElementVNode("p", _hoisted_24, _toDisplayString(activeVideoSeries.value?.description || ''), 1)
            ])
          ]),
          _createElementVNode("section", _hoisted_25, [
            _createElementVNode("div", {
              ref_key: "seasonChipsRef",
              ref: seasonChipsRef,
              class: "season-tabs"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seasons.value, (season) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: season.id,
                  type: "button",
                  class: _normalizeClass(["season-tab", { active: activeSeason.value?.id === season.id }]),
                  "data-season-id": season.id,
                  onClick: ($event: any) => (selectSeason(season.id))
                }, _toDisplayString(season.name), 11, _hoisted_26))
              }), 128))
            ], 512),
            _createElementVNode("button", {
              type: "button",
              class: "menu-toggle-btn",
              onClick: toggleSeasonSheet
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "chevron-down",
                class: _normalizeClass({ expanded: isSeasonSheetOpen.value })
              }, null, 8, ["class"])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "episode-panel-title" }, "选集", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "episode-count-btn",
              onClick: toggleEpisodeRangeSheet
            }, [
              _createElementVNode("span", null, _toDisplayString(filteredEpisodeCountText.value), 1),
              _createVNode(_component_font_awesome_icon, { icon: "chevron-right" })
            ])
          ]),
          _createElementVNode("section", _hoisted_29, [
            _createElementVNode("div", {
              ref_key: "episodeRangeChipsRef",
              ref: episodeRangeChipsRef,
              class: "episode-range-chips"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(episodeRanges.value, (range) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: range.id,
                  type: "button",
                  class: _normalizeClass(["episode-range-chip", { active: activeEpisodeRange.value == range.id }]),
                  "data-range-id": range.id,
                  onClick: ($event: any) => (selectEpisodeRange(range.id))
                }, _toDisplayString(range.label), 11, _hoisted_30))
              }), 128))
            ], 512)
          ]),
          _createElementVNode("section", {
            ref_key: "episodeGridRef",
            ref: episodeGridRef,
            class: "episode-grid"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleEpisodes.value, (episode) => {
              return (_openBlock(), _createElementBlock("article", {
                key: episode.id,
                class: _normalizeClass(["episode-card", { active: activeEpisodeId.value === episode.id }]),
                "data-episode-id": episode.id,
                onClick: ($event: any) => (selectEpisode(episode.id))
              }, [
                _createElementVNode("div", _hoisted_32, [
                  (episode.coverUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: episode.coverUrl,
                        class: "episode-cover-image"
                      }, null, 8, _hoisted_33))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass(["episode-tag", episode.status])
                  }, _toDisplayString(episode.status === 'learned' ? `已学${episode.learnCount}遍` : '未学'), 3)
                ]),
                _createElementVNode("h3", _hoisted_34, _toDisplayString(activeVideoSeries.value?.name || '') + " " + _toDisplayString(activeSeason.value?.name || '') + " " + _toDisplayString(getEpisodeNumber(episode)), 1),
                _createElementVNode("p", _hoisted_35, _toDisplayString(episode.name), 1)
              ], 10, _hoisted_31))
            }), 128))
          ], 512)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "sheet-fade" }, {
      default: _withCtx(() => [
        (isSeasonSheetOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sheet-mask",
              onClick: closeSeasonSheet
            }, [
              _createElementVNode("section", {
                class: "sheet-panel",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "sheet-title" }, "选择季数", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seasons.value, (season) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: season.id,
                    type: "button",
                    class: _normalizeClass(["sheet-option", { active: activeSeason.value?.id === season.id }]),
                    onClick: ($event: any) => (selectSeasonFromSheet(season.id))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(season.name), 1),
                    (activeSeason.value?.id === season.id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, "已选"))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_36))
                }), 128)),
                _createElementVNode("button", {
                  type: "button",
                  class: "sheet-cancel",
                  onClick: closeSeasonSheet
                }, "取消")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "sheet-fade" }, {
      default: _withCtx(() => [
        (isEpisodeRangeSheetOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sheet-mask",
              onClick: closeEpisodeRangeSheet
            }, [
              _createElementVNode("section", {
                class: "sheet-panel",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "sheet-title" }, "选择集数", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEpisodes.value, (episode, index) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: episode.id,
                    type: "button",
                    class: _normalizeClass(["sheet-option", { active: activeEpisodeId.value === episode.id }]),
                    onClick: ($event: any) => (selectEpisodeFromSheet(episode.id))
                  }, [
                    _createElementVNode("span", null, _toDisplayString(activeVideoSeries.value.name) + " " + _toDisplayString(activeSeason.value.name) + " " + _toDisplayString(index + 1) + " " + _toDisplayString(episode.name), 1),
                    (activeEpisodeId.value === episode.id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, "已选"))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_38))
                }), 128)),
                _createElementVNode("button", {
                  type: "button",
                  class: "sheet-cancel",
                  onClick: closeEpisodeRangeSheet
                }, "取消")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (isParentUnlockModalOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "parent-modal-mask",
              onClick: closeParentUnlockModal
            }, [
              _createElementVNode("section", {
                class: "parent-modal",
                onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "parent-modal-close",
                  "aria-label": "关闭",
                  onClick: closeParentUnlockModal
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "xmark" })
                ]),
                _cache[21] || (_cache[21] = _createElementVNode("header", { class: "parent-modal-header" }, [
                  _createElementVNode("h2", { class: "parent-modal-title" }, "家长模式"),
                  _createElementVNode("p", { class: "parent-modal-subtitle" }, "请输入家长密码后继续")
                ], -1)),
                _createElementVNode("form", {
                  class: "parent-modal-body",
                  onSubmit: _withModifiers(submitParentUnlockPassword, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_40, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", {
                      class: "parent-lookup-label",
                      for: "parent-unlock-password-input"
                    }, "密码", -1)),
                    _createElementVNode("div", _hoisted_41, [
                      _withDirectives(_createElementVNode("input", {
                        id: "parent-unlock-password-input",
                        ref_key: "parentPasswordInputRef",
                        ref: parentPasswordInputRef,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((parentPassword).value = $event)),
                        type: showParentPassword.value ? 'text' : 'password',
                        placeholder: "请输入密码",
                        class: "parent-input",
                        autocomplete: "current-password",
                        onInput: _cache[3] || (_cache[3] = ($event: any) => (parentPasswordError.value = ''))
                      }, null, 40, _hoisted_42), [
                        [_vModelDynamic, parentPassword.value]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "parent-input-side-btn",
                        "aria-label": showParentPassword.value ? '隐藏密码' : '显示密码',
                        title: showParentPassword.value ? '隐藏密码' : '显示密码',
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (showParentPassword.value = !showParentPassword.value))
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: showParentPassword.value ? 'eye-slash' : 'eye'
                        }, null, 8, ["icon"])
                      ], 8, _hoisted_43)
                    ]),
                    (parentPasswordError.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(parentPasswordError.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: _normalizeClass(["parent-submit-btn", { active: canSubmitParentPassword.value }]),
                    disabled: !canSubmitParentPassword.value
                  }, " 继续观看 ", 10, _hoisted_45)
                ], 32)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(LoginPromptModal, {
      modelValue: isLoginPromptOpen.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isLoginPromptOpen).value = $event)),
      onConfirm: goLogin
    }, null, 8, ["modelValue"]),
    _createVNode(VipPromptModal, {
      modelValue: isVipPromptOpen.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isVipPromptOpen).value = $event)),
      description: "成为会员后可观看完整内容",
      onConfirm: goVip
    }, null, 8, ["modelValue"])
  ]))
}
}

})